import React, { ReactElement } from "react";
import "./AuthLayout.scss";

const AuthLayout: React.FC<{ children: ReactElement }> = ({ children }) => {
  return <div className="AuthLayout">{children}</div>;
};

export default AuthLayout;
